import React, { useState } from 'react';
import translate from 'react-polyglot/lib/translate';
import add from 'date-fns/add';
import format from 'date-fns/format';
import formatDistance from 'date-fns/formatDistance';
import { OnChange } from 'react-final-form-listeners';
import { differenceInMilliseconds, differenceInSeconds } from 'date-fns';
import { Field, FormSpy, useFormState } from 'react-final-form';

import { required } from '../../helpers/formValidators';
import { FormInputHolder, FormLabel, FormDateInput, FormTimeInput } from '../form';

export const addDateAndTimeFields = (dateTimestamp, timeTimestamp) => {
  dateTimestamp = format(new Date(dateTimestamp), "yyyy-MM-dd'T'");
  timeTimestamp = format(new Date(timeTimestamp), "HH:mm:ss.SSSxxx");

  return new Date(dateTimestamp + timeTimestamp);
}

export const getDuration = (startTime, endTime) => {
  if (!startTime || !endTime) {
    return;
  }

  return formatDistance(new Date(startTime), new Date(endTime), { includeSeconds: true });
}

export const getDurationStrict = (startTime, endTime) => {
  if (!startTime || !endTime) {
    return;
  }

  return differenceInMilliseconds(new Date(endTime), new Date(startTime));
}

const Duration = props => {
  const {
    t
  } = props;

  const form = useFormState()
  const [startTime, setStartTime] = useState(new Date(form.values.date));
  const [endTime, setEndTime] = useState(
    form.values.endTime ? new Date(form.values.endTime) : add(startTime, {minutes: 10})
  )
  const [totalTime, setTotalTime] = useState(getDuration(startTime, endTime));

  // disable any times that occur before the startDate
  const filterBeforeStart = (time) => {
    // time is based on new Date(), whereas startTime could be based on a date in the past
    // to correctly compare, we'll assign each time to the current day
    const start = addDateAndTimeFields(new Date(), new Date(startTime));
    const given = addDateAndTimeFields(new Date(), new Date(time));

    return start.getTime() < given.getTime();
  }

  return (
    <div>
      <FormDateInput
        name={"date"}
        initialValue={startTime}
        labelRenderer={() => (<FormLabel for="date">{t('tracker.date')}</FormLabel>)}
        validate={required}
        dateFormat='MMM, dd yyyy'
      />

      <FormInputHolder>
        <FormTimeInput
          name={"startTime"}
          labelRenderer={() => (<FormLabel for="startTime">{t('tracker.startTime')}</FormLabel>)}
          initialValue={startTime}
          validate={required}
        />

        <Field name="endTime" subscription={{}}>
          {(
            { input: { onChange } }
          ) => (
            <OnChange name="startTime">
              {(newStart, previousStart) => {
                // get the current duration
                const duration = differenceInSeconds(endTime, previousStart);
                // add the duration to the new startTime to calculate endTime
                const newEnd = add(newStart, { seconds: duration });
                // set the endTime value accordingly
                onChange(newEnd);
              }}
            </OnChange>
          )}
        </Field>

        <FormTimeInput
          name={"endTime"}
          labelRenderer={() => (<FormLabel for="endTime">{t('tracker.endTime')}</FormLabel>)}
          initialValue={endTime}
          validate={required}
          filterTime={filterBeforeStart}
        />
      </FormInputHolder>

      <div className="total-time">
        <FormLabel>Total Time</FormLabel>
        <span>{totalTime}</span>
      </div>

      <FormSpy
        subscription={{ values: true, errors: true }}
        onChange={({ values, errors }) => {
          setStartTime(values.startTime)
          setEndTime(values.endTime);

          if (values.endTime && values.startTime && !errors.endTime) {
            setTotalTime(getDuration(values.startTime, values.endTime))
          } else {
            setTotalTime('');
          }
        }}
      />
    </div>
  )
}

export default translate()(Duration);



// WEBPACK FOOTER //
// ./src/components/ActivityTracker/Duration.js